module.exports = __webpack_public_path__ + "img/maker-3.9395f905.jpg";